module.exports = __webpack_public_path__ + "img/li-img.fbf255a2.png";